import styled, { css } from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { Font12, Font14 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'

export const BreakerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const BreakerSearchWrapper = styled.div`
  margin-bottom: 16px;
`

export const Bold = styled.span`
  font-weight: bold;
`

export const PanelTableWrapper = styled.span`
  width: 100%;
  display: flex;
  margin-top: 20px;
  & > * {
    flex-grow: 1;
  }
`

export const PanelInfoRow = styled.div`
  margin-top: 16px;
  gap: 8px;
  display: flex;
  width: 100%;
  justify-content: space-between;

  @media ${theme.devices.mobile} {
    flex-direction: column;
  }
`

export const PanelInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PanelInfoText = styled.div`
  margin-bottom: 28px;
  font-size: 16px;
  font-weight: 325;
  line-height: 20px;
`

export const PanelInfoHeaderText = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.colors.moreGrey};
`

export const TableLeft = css`
  border-radius: 8px 0 0 8px;
`

export const TableRight = css`
  border-radius: 0 8px 8px 0;
`

export const TableLeftRow = css`
  :last-child {
    border-radius: 0 0 0 8px;
  }
`

export const TableRightRow = css`
  :last-child {
    border-radius: 0 0 8px 0;
  }
`

export const StyledMForwardIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const RadioTilesWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`

export const InfoGrid = styled.div`
  display: grid;
  gap: 8px;

  @media ${theme.devices.tablet} {
    grid-template-columns: auto auto auto;
  }
  @media ${theme.devices.desktop} {
    grid-template-columns: auto auto auto auto auto;
  }
`

export const StyledArrowIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
  transition: transform 0.2s ease;
`

export const StatusWrapper = styled.div<{ status: boolean }>`
  display: flex;
  gap: 14px;
  // height: 40px;
  padding: 6px 12px;
  align-items: center;
  color: ${theme.colors.otterWarmBlack};
  border-radius: 8px;
  background: ${({ status }) =>
    status ? theme.colors.successBack : theme.colors.unsuccessBack};
  ${Font14};
  font-weight: bold;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const NavBack = styled.div`
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  gap: 28px;
  &:hover {
    cursor: pointer;
  }
`

export const BreakerGrid = styled.div`
  margin-top: 16px;
  display: flex;
  width: 100%;
  gap: 16px;

  @media ${theme.devices.mobile} {
    flex-direction: column;
  }
`

export const BreakerBlock = styled(WhiteBlock)`
  flex: 1;

  @media ${theme.devices.mobile} {
    flex-shrink: 0;
    flex-grow: 1;
  }
`

export const ChannelCellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
`

export const ChannelText = styled.div`
  ${Font12};
`

export const ChannelMobileWrapper = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
`

export const NameSpan = styled.span`
  color: ${theme.colors.otterWarmBlack};
  font-weight: 700;
`
